$(function () {
    $('.js-table-accordion-trigger').on('click', function(e) {
        var id = $(this).data('accordion-id');
        var $content = $('.js-table-accordion-content[data-accordion-id="' + id + '"]');

        // var a
        $(this).toggleClass('table-accordion-open');
        $content.toggle();
    });

    $('.js-resend-invoice__trigger').click(function (e) {
        e.preventDefault();
        var $link = $(this);
        if ($link.hasClass('disabled')) {
            return;
        }
        $link.addClass('disabled');
        var $container = $link.closest('.js-resend-invoice');
        var $message = $container.find('.js-resend-invoice__message');

        $.getJSON($link.attr('href'))
            .done(function(data) {
                if (data.success) {
                    $link.remove();
                } else {
                    $link.removeClass('disabled');
                }
                $message.text(data.message);
            })
            .fail(function(data) {
                $message.text('Unable to resend invoice, please try again');
                $link.removeClass('disabled');
            });
    });
});
